import React, { useState } from "react";
import Contact from "../contact";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/TSS.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaClock, FaBriefcase, FaUsers, FaGraduationCap, FaCheckCircle } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const SkillsInDemandVisa482 = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <Helmet>
        <title>Skills in Demand Visa (Subclass 482) – Immiget Global Australia</title>
        <meta
          name="description"
          content="Apply for Skills in Demand Visa (Subclass 482) - Temporary Skill Shortage (TSS) Visa. Expert guidance for skilled workers seeking Australian employment opportunities."
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Skills in Demand (Subclass 482)
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Individual & Families
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Skills in Demand (Subclass 482)
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="text-xl max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            What is the Skills in Demand Visa (Subclass 482)?
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg font-normal">
            At Immiget Global, we specialize in helping skilled professionals navigate Australia's immigration pathways. The Skills in Demand Visa (Subclass 482), formerly known as the Temporary Skill Shortage (TSS) Visa, enables Australian employers to sponsor skilled workers from overseas to fill positions they are unable to fill with local talent.
          </p>
          
          {/* Key Benefits */}
          <div className="mt-6">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3 max-xl:text-center">Your Pathway to Working and Living in Australia</h3>
            <p className="text-blue text-lg hellix-font max-xl:text-center">
              The Subclass 482 Visa is a temporary, employer-sponsored visa that allows skilled workers to live and work in Australia. This visa is designed to address labor shortages by enabling employers to hire overseas workers for positions they cannot find suitable Australian candidates to fill.
            </p>
          </div>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Skills in Demand Visa" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Visa Streams */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Visa Streams
          </h1>
        </div>
        <p className="text-blue font-normal text-lg mt-2 hellix-font">
          The Skills in Demand Visa includes three streams:
        </p>
        
        <div className="mt-6 space-y-6">
          {/* Core Skills Stream */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <FaBriefcase className="text-blue text-2xl" />
              <h3 className="text-blue text-xl font-semibold hellix-font">
                1. Core Skills Stream
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div className="flex items-center gap-2">
                <FaClock className="text-blue" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Duration:</span>
                  <span className="text-blue hellix-font"> Up to 4 years</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-blue" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Eligibility:</span>
                  <span className="text-blue hellix-font"> Occupations listed on the Core Skills Occupation List (CSOL)</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <img src={permanentIcon} alt="pr-icon" className="w-5 h-5" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Pathway to PR:</span>
                  <span className="text-blue hellix-font"> Eligible after 2 years of full-time work with the sponsoring employer</span>
                </div>
              </div>
            </div>
          </div>

          {/* Specialist Skills Stream */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <FaGraduationCap className="text-blue text-2xl" />
              <h3 className="text-blue text-xl font-semibold hellix-font">
                2. Specialist Skills Stream
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div className="flex items-center gap-2">
                <FaClock className="text-blue" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Duration:</span>
                  <span className="text-blue hellix-font"> Up to 4 years</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-blue" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Eligibility:</span>
                  <span className="text-blue hellix-font"> Highly skilled professionals earning a salary of $135,000 or more</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <img src={permanentIcon} alt="pr-icon" className="w-5 h-5" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Pathway to PR:</span>
                  <span className="text-blue hellix-font"> Eligible after 2 years of full-time work with the sponsoring employer</span>
                </div>
              </div>
            </div>
          </div>

          {/* Labour Agreement Stream */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <FaUsers className="text-blue text-2xl" />
              <h3 className="text-blue text-xl font-semibold hellix-font">
                3. Labour Agreement Stream
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div className="flex items-center gap-2">
                <FaClock className="text-blue" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Duration:</span>
                  <span className="text-blue hellix-font"> Up to 4 years</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-blue" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Eligibility:</span>
                  <span className="text-blue hellix-font"> Employers with a labor agreement with the Australian Government</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <img src={permanentIcon} alt="pr-icon" className="w-5 h-5" />
                <div>
                  <span className="text-blue font-semibold hellix-font">Pathway to PR:</span>
                  <span className="text-blue hellix-font"> Dependent on the terms of the labor agreement</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligibility Requirements */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Eligibility Requirements
          </h1>
        </div>
        <div className="text-blue font-normal text-lg mt-2 hellix-font">
          To be eligible for the Subclass 482 Visa, you must:
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg font-normal hellix-font">
              Have a valid job offer from an approved Australian sponsor
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg font-normal hellix-font">
              Possess the necessary skills and qualifications for the nominated occupation
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg   font-normal hellix-font">
              Demonstrate at least 2 years of relevant work experience
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg   font-normal hellix-font">
              Meet English language proficiency requirements
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg   font-normal hellix-font">
              Undergo health and character checks
            </div>
          </div>
        </div>
        
        <div className="mt-6 bg-blue/10 p-4 rounded-lg">
          <p className="text-blue text-lg hellix-font">
            <strong>Note:</strong> Employers must also be approved sponsors and demonstrate a genuine need for a skilled worker.
          </p>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Benefits Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Benefits of the Subclass 482 Visa
          </h1>
        </div>
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={unlimitedIcon} alt="work-icon" />
            </div>
            <div className="text-blue text-xl font-normal text-center hellix-font">
              Work full-time in your nominated occupation
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={materialIcon} alt="family-icon" />
            </div>
            <div className="text-blue text-xl font-normal text-center hellix-font">
              Include family members in your application
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={permanentIcon} alt="pr-icon" />
            </div>
            <div className="text-blue text-xl font-normal text-center hellix-font">
              Pathway to permanent residency through ENS (Subclass 186)
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={medicareIcon} alt="healthcare-icon" />
            </div>
            <div className="text-blue text-xl font-normal max-md:px-2 text-center hellix-font">
              Access to Australia's high quality of life, including healthcare and education
            </div>
          </div>
        </div>
      </div>

      {/* Application Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="  text-2xl text-blue font-semibold hellix-font">
            Application Process
          </h1>
        </div>
        <p className="text-blue font-normal text-lg    mt-2 hellix-font">
          The application process involves three steps:
        </p>
        <div className="lg:ml-8 hellix-font mt-3">
          <div className="flex gap-2">
            <div className="hellix-font text-lg    font-semibold text-blue">
              Step 1:
            </div>
            <div className="hellix-font text-lg    font-normal text-blue">
              <strong>Employer Sponsorship Application:</strong> Your employer must apply to become an approved sponsor
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg    font-semibold text-blue">
              Step 2:
            </div>
            <div className="hellix-font text-lg    font-normal text-blue">
              <strong>Nomination Application:</strong> Your employer nominates you for the specific position
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg    font-semibold text-blue">
              Step 3:
            </div>
            <div className="hellix-font text-lg    font-normal text-blue">
              <strong>Visa Application:</strong> You apply for the visa, providing all necessary documentation
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="  text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg    mt-2 hellix-font">
          With years of experience and a high success rate, Immiget Global provides:
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg    font-normal hellix-font">
              Tailored Visa Strategy
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg    font-normal hellix-font">
              End-to-End Application Support
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg    font-normal hellix-font">
              Compliance and Document Guidance
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg    font-normal hellix-font">
              Job Matching with Approved Sponsors
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg    font-normal hellix-font">
              Post-Arrival Settlement Support
            </div>
          </div>
        </div>
        <p className="text-blue text-lg    mt-4 hellix-font italic">
          We simplify the complexity so you can focus on your future.
        </p>
        
        {/* CTA Button */}
        <div className="mt-6 text-center">
          <button 
            onClick={scrollToContact}
            className="bg-blue text-white px-8 py-3 rounded-lg font-semibold hellix-font hover:bg-blue-700 transition-colors text-lg"
          >
            Get Started Today
          </button>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Immiget Will Help You */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={helpIcon} alt="help" />
          </div>
          <h1 className="  text-2xl text-blue font-semibold hellix-font">
            How Immiget Will Help You?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg    mt-2 hellix-font">
          Whether you're an individual seeking better opportunities or an employer facing skill shortages, Immiget Global is your trusted partner in navigating the Subclass 482 visa process.
        </div>
        <div className="xl:flex gap-6 mt-4">
          <div className="xl:w-[50%]">
            <img src={helpImage} alt="help" className="h-[100%]" />
          </div>
          <div className="xl:w-[50%] max-xl:mt-4 flex flex-col gap-1">
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl    hellix-font font-semibold">
                  Visa Strategy Development:
                  <span className="font-normal">
                    We assess your qualifications and match you with the most suitable visa stream for your circumstances.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl    hellix-font font-semibold">
                  Employer Sponsorship Support:
                  <span className="font-normal">
                    We guide employers through the sponsorship process and help match skilled workers with suitable positions.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl    hellix-font font-semibold">
                  Application Management:
                  <span className="font-normal">
                    We handle all three stages of the application process, ensuring compliance and timely submission.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl    hellix-font font-semibold">
                  Settlement Support:
                  <span className="font-normal">
                    We provide post-arrival assistance and guidance on transitioning to permanent residency.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="text-2xl text-center text-blue font-semibold hellix-font">
          Skills in Demand Visa FAQs
        </h1>
        <p className="text-blue font-normal text-center hellix-font">
          Get answers to common questions about the Subclass 482 Skills in Demand Visa.
        </p>

        <div className="accordion-container mt-8">
          {/* FAQ 1 */}
          <div className="accordion">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(1)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                1. Need a Work Visa? Apply for Australia's Skills in Demand Visa Today!
              </h2>
              {activeIndex === 1 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  The SID Visa, also known as Subclass 482, is a temporary work visa designed to address skill shortages in Australia by allowing skilled workers to work for an approved sponsor. It offers flexibility, a pathway to permanent residency, and caters to various industries and skill levels.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 2 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(2)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                2. How long is the SID visa valid?
              </h2>
              {activeIndex === 2 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  The SID visa is valid for up to four years, providing stability for visa holders and their employers.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 3 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(3)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                3. Can I apply for permanent residency through the SID visa?
              </h2>
              {activeIndex === 3 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 3 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, all SID visa holders, regardless of the stream, have a clear pathway to permanent residency through the Employer Nomination Scheme (Subclass 186). Time spent working under the SID visa counts toward the residency requirements, even if you change employers.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 4 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(4)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                4. What are the streams under the SID visa?
              </h2>
              {activeIndex === 4 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 4 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Specialist Skills Stream: For high-income earners ($135,000+ annually) with priority processing.<br/>
                  Core Skills Stream: For a broader range of occupations, including trades and healthcare roles, with a minimum salary threshold of $73,150.<br/>
                  Labour Agreement Stream: For lower-paid skilled workers under approved labour agreements, focusing on sectors like aged care and support services.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 5 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(5)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                5. What is the Core Skilled Threshold (CST) salary?
              </h2>
              {activeIndex === 5 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 5 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  The CST salary is the minimum annual income required for the Core Skills Stream, currently set at $73,150. It is reviewed and indexed annually to reflect economic changes.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 6 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(6)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                6. How can I find a sponsor for the SID visa?
              </h2>
              {activeIndex === 6 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 6 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  The Australian government provides a public register of approved business sponsors. This resource allows potential visa applicants to identify suitable employers who can sponsor them.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 7 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(7)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                7. What is the processing time for the SID visa?
              </h2>
              {activeIndex === 7 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 7 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Specialist Skills Stream: 7 days<br/>
                  Core Skills Stream: 21 days (median processing time)<br/>
                  Labour Agreement Stream: Processing times may vary depending on the sponsor's agreement.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 8 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(8)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                8. Can I change employers while on the SID visa?
              </h2>
              {activeIndex === 8 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 8 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, you can change employers without resetting your time towards permanent residency. However, the new employer must be an approved sponsor under the SID visa program.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 9 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(9)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                9. Are family members allowed to accompany me on this visa?
              </h2>
              {activeIndex === 9 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 9 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, eligible family members, such as your spouse and dependent children, can be included in your application and join you in Australia.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 10 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(10)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                10. What occupations are eligible under the SID visa?
              </h2>
              {activeIndex === 10 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 10 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Specialist Skills Stream: Open to most occupations except trades, machinery operators, drivers, and labourers.<br/>
                  Core Skills Stream: Occupations listed on the Core Skills Occupation List (CSOL).<br/>
                  Labour Agreement Stream: Occupations agreed upon between the employer and the government.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 11 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(11)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                11. What happens if I earn below the Core Skilled Threshold (CST)?
              </h2>
              {activeIndex === 11 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 11 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  If your salary is below the CST, you may still qualify for the Labour Agreement Stream, provided your sponsor has an approved labour agreement with the Australian government.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 12 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(12)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                12. Can my visa be extended?
              </h2>
              {activeIndex === 12 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 12 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, the SID visa can be extended as long as you meet the eligibility criteria and continue to be sponsored by an approved employer.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 13 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(13)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                13. How does the SID visa address Australia's skill shortages?
              </h2>
              {activeIndex === 13 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 13 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  The SID visa aligns skilled workers with industries facing shortages, including healthcare, construction, and essential services. It ensures that employers can fill critical roles with qualified individuals from around the world.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 14 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(14)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                14. Is there a language requirement for the SID visa?
              </h2>
              {activeIndex === 14 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 14 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, applicants typically need to demonstrate English proficiency, which can be proven through tests such as IELTS, PTE, or TOEFL, unless exempted.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 15 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(15)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                15. What should I do if my visa application is refused?
              </h2>
              {activeIndex === 15 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 15 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  If your SID visa application is refused, you may have the option to appeal the decision through the Administrative Appeals Tribunal (AAT). It's advisable to seek professional assistance for the appeal process.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default SkillsInDemandVisa482;